import { z } from "zod";

export const emailConfirmationSchema = z.object({
  registeredEmail: z.string(),
  alternativeEmail: z
    .string()
    .optional()
    .refine(
      (value) => {
        if (!value || value === "") return true;
        // メールアドレスの形式をチェック: [ユーザー名]@[ドメイン名].[トップレベルドメイン]
        // 例: user@example.com
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      },
      {
        message: "メールアドレスを正しく入力してください。",
      },
    ),
});

export type EmailConfirmationValues = z.infer<typeof emailConfirmationSchema>;
